<template>
  <div class="modal-card" style="width: 500px">
    <header class="modal-card-head is-small">
      <p class="modal-card-title">住所検索</p>
      <span class="v-icon-close" @click="$emit('close')">
        <b-icon size="is-medium" pack="fa" icon="window-close"> </b-icon>
      </span>
    </header>
    <section class="modal-card-body v-custorm-body">
      <div class="column">
          <div class="field">
            <b-field label="郵便番号">
              <b-input class="input-text" v-model="zipCodeInput" />
            </b-field>
          </div>
          <div class="field" style="text-align: right;">
            <b-button class="field"
              label="検索"
              @click="callZipCloudApiToGetAddressByZipcode"/>
          </div>
      </div>
      <div class="column">
          <div class="field">
            <b-field label="住所">
              <b-input 
              type="textarea"
              class="input-text"  v-model="addressResult"/>
            </b-field>
          </div>
          <div class="field" style="text-align: right;">
            <b-button class="field"
              label="セット"
              @click="populateAdressToParentItem();$emit('close')"/>
          </div>
      </div>
      <div class="column">
        <b-label v-model="errorMessage"/>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: [
    'item',
  ],
  data: () => ({
    zipCodeInput: '',
    addressResult: '',
    errorMessage: '',
  }),
  computed: {
    
  },
  methods: {
    async fetchJsonp(endpoint) {
      return await axios({
        method: 'GET',
        url: `${endpoint}`,
        timeout: 10000
      });
    },
    async callZipCloudApiToGetAddressByZipcode() {
      try {
        const zipCodeValue = this.zipCodeInput.toString().trim();
        const api = `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipCodeValue}`;
        const reponse = await this.fetchJsonp(api);
        const result = reponse.data.results[0]
        this.addressResult =`${result.address1}${result.address2}${result.address3}`
      } catch(e) {
        this.errorMessage = e.message;
      }
    },
    populateAdressToParentItem() {
      this.item.addressByZipcode = this.addressResult;
    }
  },
};
</script>
